import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
// import querystring from 'querystring'

// const userApi = {
//   detail (userId, params) {
//     return axios.get(`api/users/${userId}/`, {params: params})
//   }
// }

const userApi = {
  wechatProfile (params) {
    return axios.get(`${ApiSetting.baseUrl}/api/wechatprofiles/`, {params: params})
  }
}

export default userApi
